export function priceToNumber (price) {
  if (price === Number(price)) return price

   // eslint-disable-next-line
  return parseFloat(price.replace(/\./g, "").replace(/\,/g, "."))
}